query BulkAwaitingReviewCount($campaignId: ID!, $libraryFilters: InputLibraryFilters!) {
    computeDeliverables(campaignId: $campaignId, libraryFilters: $libraryFilters, page: 1, perPage: 1, preview: false) {
        pagination {
            totalCount
        }
    }
}
